import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { ExpressSetupStatuses } from '@/modules/ExpressSetup/ExpressSetup.types';


interface Props {
  organizationId?: string;
  enabled?: boolean;
}

const useGetExpressSetupStatusQuery = ({ organizationId, enabled }: Props) => {
  const { data, isLoading, isSuccess } = useQuery(
    [organizationId],
    () => api.get(API_URL.EXPRESS_SETUPS_BY_ORGANIZATION_ID(organizationId || '')),
    { enabled: !!organizationId && !!enabled }
  );

  const expressSetupStatus = useMemo(
    () => data?.data?.status_type as unknown as ExpressSetupStatuses,
    [data]
  );

  return {
    expressSetupStatus,
    isLoading,
    isSuccess,
  };
};

export default useGetExpressSetupStatusQuery;
